import { createStyles } from 'antd-style';
import { colors } from 'theme/colors';

export const useMenuStyles = createStyles(({ css, token }) => ({
  menuGreen: css`
    /* Safari-specific fixes for smooth transitions */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;

    /* Improve Safari rendering performance */
    .ant-menu-inline-collapsed {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }

    /* Fix Safari transition issues */
    .ant-menu-item,
    .ant-menu-submenu-title {
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
    }

    /* Custom padding for menu items - only when NOT collapsed */
    &:not(.ant-menu-inline-collapsed) .ant-menu-item,
    &:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }

    /* Ensure submenu items also get the custom padding when NOT collapsed */
    &:not(.ant-menu-inline-collapsed) .ant-menu-submenu .ant-menu-item {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }

    /* Create wrapper div for active submenu items */
    &:not(.ant-menu-inline-collapsed) .ant-menu-submenu-open .ant-menu {
      background-color: ${colors.primaryGreen6} !important;
      border-radius: 8px !important;
      padding: 4px !important;
      margin: 4px !important;
    }

    /* Style submenu items within active submenu */
    &:not(.ant-menu-inline-collapsed)
      .ant-menu-submenu-open
      .ant-menu
      .ant-menu-item {
      padding-left: 28px !important;
      padding-right: 20px !important;
      height: 32px !important;
      line-height: 32px !important;
      margin: 4px 0 !important;
    }

    /* Force parent submenu highlighting when child is selected - only when collapsed */
    &.ant-menu-inline-collapsed
      .ant-menu-submenu-open
      > .ant-menu-submenu-title,
    &.ant-menu-inline-collapsed
      .ant-menu-submenu:has(.ant-menu-item-selected)
      > .ant-menu-submenu-title,
    &.ant-menu-inline-collapsed
      .ant-menu-submenu.ant-menu-submenu-selected
      > .ant-menu-submenu-title,
    &.ant-menu-inline-collapsed
      .ant-menu-submenu-active
      > .ant-menu-submenu-title,
    &.ant-menu-inline-collapsed
      .ant-menu-submenu[data-menu-list*='true']
      > .ant-menu-submenu-title {
      background-color: ${colors.primaryGreen4} !important;
      color: ${colors.colorWhite} !important;
    }
  `,
  tooltipStyles: css`
    /* Styles for popup menu that appears when hovering over collapsed menu items */
    .ant-menu-inline-collapsed-tooltip .ant-tooltip-inner,
    .ant-menu-vertical-collapsed-tooltip .ant-tooltip-inner {
      background-color: ${colors.colorWhite} !important;
      color: ${token.colorPrimary} !important;
      box-shadow:
        0 3px 6px -4px rgba(0, 0, 0, 0.12),
        0 6px 16px 0 rgba(0, 0, 0, 0.08),
        0 9px 28px 8px rgba(0, 0, 0, 0.05);
    }

    /* Arrow color for the popup tooltip */
    .ant-menu-inline-collapsed-tooltip .ant-tooltip-arrow-content,
    .ant-menu-vertical-collapsed-tooltip .ant-tooltip-arrow-content {
      background-color: ${colors.colorWhite} !important;
    }
  `,
  popupSubmenuStyles: css`
    /* For popup submenus that appear when menu is collapsed */
    .ant-menu-submenu-popup .ant-menu-item:hover {
      color: ${token.colorPrimary} !important;
      background-color: ${colors.primaryGreen1} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item-selected {
      background-color: ${colors.primaryGreen2} !important;
      color: ${token.colorPrimary} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item-active {
      color: ${token.colorPrimary} !important;
    }

    .ant-menu-submenu-popup .ant-menu-submenu-title:hover {
      color: ${token.colorPrimary} !important;
      background-color: ${colors.primaryGreen1} !important;
    }

    .ant-menu-submenu-popup .ant-menu-submenu-active > .ant-menu-submenu-title {
      color: ${token.colorPrimary} !important;
    }
  `,
}));
